import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../lib/api';

export const fetchDocuments = createAsyncThunk(
  'docs/fetch',
  async ({ type = '', page = 1 }) => {
    const params = new URLSearchParams();
    if (type) params.append('source_type', type);
    params.append('page', page);

    const res = await api.get(`/documents/?${params.toString()}`);
    return res.data;
  }
);

export const deleteDocument = createAsyncThunk(
  'docs/delete',
  async ({ id }) => {
    await api.delete(`/documents/${id}/`);
    return id;
  }
);

const documentSlice = createSlice({
  name: 'documents',
  initialState: {
    list: [],
    loading: false,
    currentPage: 1,
    totalPages: 1,
    filterType: '',
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setFilterType: (state, action) => {
      state.filterType = action.payload;
      state.currentPage = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocuments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.results;
        state.totalPages = Math.ceil(action.payload.count / 10);
      })
      .addCase(deleteDocument.fulfilled, (state, action) => {
        state.list = state.list.filter((doc) => doc.id !== action.payload);
      });
  },
});

export const { setPage, setFilterType } = documentSlice.actions;
export default documentSlice.reducer;
